import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import { type ReactNode, useEffect, useState } from 'react'
import { getMaintenance } from 'services/maintenance'
import Loader from 'ui/atoms/Loader'
import MaintenanceAlert from './MaintenanceAlert'

const checkIsUnderMaintenance = (startTime: string, endTime: string): boolean =>
  isAfter(new Date(), new Date(startTime)) &&
  isBefore(new Date(), new Date(endTime))

interface MaintenanceState {
  message: string
  underMaintenance: boolean
}

interface MaintenanceProps {
  children: ReactNode
}

const Maintenance = ({ children }: MaintenanceProps) => {
  const [maintenance, setMaintenance] = useState<MaintenanceState>({
    underMaintenance: false,
    message: ''
  })
  const [isLoading, setIsLoading] = useState(true)

  const { underMaintenance, message } = maintenance

  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
        const {
          downTime: { startDateTime, stopDateTime, downTimeMessage }
        } = await getMaintenance()

        setMaintenance({
          message: downTimeMessage,
          underMaintenance: checkIsUnderMaintenance(startDateTime, stopDateTime)
        })
      } catch (e) {
        // Do nothing on error
      } finally {
        setIsLoading(false)
      }
    }
    fetchMaintenance()
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      {underMaintenance && <MaintenanceAlert message={message} />}
      {!underMaintenance && children}
    </>
  )
}

export default Maintenance
